import React from 'react'
import { Disclosure , Transition} from '@headlessui/react'
import * as Icon from 'react-feather'
const TableGroup = (props) => {
    return (
        <>
        <Disclosure.Button className="inline-flex items-center py-1 font-bold text-left focus:outline-none">
            <Icon.ChevronUp className={`${props.isOpen ? '' : 'transform rotate-180' } w-5 h-5 mr-3 transition ease-in-out`} />
            <span>{props.title}</span>
        </Disclosure.Button>
        <Transition
        enter="transition duration-150 ease-in"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-150 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Disclosure.Panel static className={`mb-2 text-sm row-group   ${props.isFirst ? "row-group-first" : ""} `}>
            {props.children}
        </Disclosure.Panel>
        </Transition>
    </>
    )
}

export default TableGroup

